<template>
    <div>
      <div class="container">
        <div class="handle-box">
          <el-input v-model="query.room_name" placeholder="房间名" class="handle-input mr10"></el-input>
          <el-cascader :props="props"
                       v-model="area_store"
                       placeholder="选择或搜索门店"
                       collapse-tags
                       clearable
                       filterable></el-cascader>
          <el-select v-model="query.is_validate" clearable placeholder="是否有效" class="handle-select mr10">
            <el-option key="1" label="有效" value="1"></el-option>
            <el-option key="2" label="无效" value="0"></el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
        </div>
        <el-table
            :data="tableData"
            border
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
        >
          <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
          <el-table-column prop="room_name" label="房间名" align="center"></el-table-column>
          <el-table-column label="封面" prop="cover" align="center" width="100">
            <template #default="scope">
              <el-image
                  class="table-td-thumb"
                  :src="scope.row.cover"
                  :preview-src-list="[scope.row.cover]"
                  :hide-on-click-modal="true"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="价格(元)"  align="right" width="100">
            <template #default="scope"  align="right">
              {{ parseFloat(scope.row.price / 100).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="sales" label="销售量" align="center" width="100"></el-table-column>
          <el-table-column prop="true_sales" label="真实销量" align="center" width="100"></el-table-column>
          <el-table-column prop="store_name" label="所属门店" align="center"></el-table-column>
          <el-table-column prop="sort" align="center" label="排序" width="100">
            <template #default="scope">
              <el-input-number style="width: 70px;" v-model="scope.row.sort" :controls="false"
                               @change="setSort(scope.row.id, scope.row.sort)"
                               :precision="0" :step="1" :min="0" :max="10">
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="是否有效" width="100" align="center">
            <template #default="scope">
                {{ scope.row.is_validate ? "有效" : "无效" }}
            </template>
          </el-table-column>
          <el-table-column prop="c_at" :formatter="dateFormat" align="center" label="添加时间"
                           width="200"></el-table-column>
          <el-table-column label="操作" width="150" header-align="center">
            <template #default="scope">
              <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="handleEdit(scope.$index, scope.row)"
              >编辑
              </el-button>
              <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="handleMeal(scope.row.id)"
              >套餐
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
              background
              layout="total, prev, pager, next"
              :current-page="query.page"
              :page-size="query.page_size"
              :total="pageTotal"
              @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </div>
      <!-- 编辑弹出框 -->
      <el-dialog title="编辑" v-model="editVisible" width="60%" >
        <el-form ref="form" :model="form" class="el-dialog__body" label-width="180px" :rules="rules">
          <el-form-item label="房间名" prop="room_name">
            <el-input v-model="form.room_name" class="w200" disabled></el-input>
          </el-form-item>
          <el-form-item label="所属门店">
            <el-select v-model="form.store_id" placeholder="请选择" style="width: 200px;" disabled>
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="封面">
            <el-alert title="建议尺寸500（长）*500（宽）" type="success" style="margin-bottom: 10px;"/>
              <label for="file">
                <el-avatar shape="square" :size="150" fit="cover" :src="form.cover"></el-avatar>
                <p style="color: #409EFF;">点击修改封面</p>
              </label>
              <input @change="onFileChange"  id="file" type="file" hidden ref="file">
            <el-button type="text" @click="form.cover = ''" style="color: red">删除</el-button>
          </el-form-item>
  
          <el-form-item label="轮播图">
            <el-alert title="建议尺寸780（长）*560（宽）" type="success" style="margin-bottom: 10px;"/>
            <template v-for="(item, index) in form.image_list" :key="index">
              <div style="float:left; margin: 5px;">
                <img :src="item" class="avatar">
                <el-button type="text" @click="form.image_list.splice(index, 1)" style="color: red">删除</el-button>
              </div>
            </template>
            <el-upload
                class="avatar-uploader upload"
                :action="action"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadAvatarFile"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="标签">
            <el-input v-model="form.label" style="width: 180px;" />
          </el-form-item>
          <el-form-item label="成本(每小时)" prop="cost">
            <el-input-number v-model="form.cost" :precision="2" :min="0" :controls="false" :max="4294967295"/>
            元
          </el-form-item>
          <el-form-item label="价格(每小时)" prop="price">
            <el-input-number v-model="form.price" :precision="2" :min="0" :controls="false" :max="4294967295"/>
            元
          </el-form-item>
          <el-form-item label="展示销量">
            <el-input-number v-model="form.sales" :precision="0" :min="0" :controls="false" :max="4294967295"/>
            &nbsp;&nbsp;&nbsp;<b>真实销量:{{ form.true_sales }}</b>
          </el-form-item>

        </el-form>
        <template #footer>
                  <span class="dialog-footer">
                      <el-button @click="editVisible = false">取 消</el-button>
                      <el-button type="primary" @click="saveEdit">确 定</el-button>
                  </span>
        </template>
      </el-dialog>
  
      <!-- 套餐弹出框 -->
      <el-dialog title="选择套餐" v-model="editMealVisible" width="65%">
        <el-form ref="form" :model="form" class="el-dialog__body" label-width="180px">
            <div style="text-align: center">
              <el-transfer
                  v-model="chooseMeals"
                  style="text-align: left; display: inline-block"
                  :render-content="renderFunc"
                  filterable
                  :titles="['可选套餐', '已选套餐']"
                  :format="{
                      noChecked: '${total}',
                      hasChecked: '${checked}/${total}',
                    }"
                  :data="meals"
                  @change="handleChange"
              >
              </el-transfer>
            </div>
        </el-form>
        <template #footer>
                  <span class="dialog-footer">
                      <el-button @click="editMealVisible = false">取 消</el-button>
                      <el-button type="primary" @click="saveRoomMeal()">确 定</el-button>
                  </span>
        </template>
      </el-dialog>
  
      <el-dialog
          @opened="onDialogOpened"
          @closed="onDialogClosed"
          :append-to-body="true"
          title="修改封面"
          v-model="dialogVisible"
      >
        <div class="preview-image-wrap" >
          <img ref="preview-image" height="500" class="preview-image" :src="previewImage" alt="">
        </div>
        <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onUpdatePhoto" :loading="updatePhotoLoading">确 定</el-button>
        </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import {getRoomList, deleteRoom, saveRoom, setRoomIsvalidate, setRoomSort, getRoomDetail} from "@/api/room";
  import moment from "moment";
  import {getAreaOption, getStoreOption} from "@/api/store";
  import {addRoomMeal, getAllMeal, getRoomMeal} from "@/api/meal";
  import Cropper from 'cropperjs';
  import 'cropperjs/dist/cropper.css';
  import {dataURLtoFile, imgCompress} from "@/utils/compress";
  import {upload} from "@/api/editor";
  
  export default {
    name: "RoomTable",
  
    data() {
      return {
        action: '#',
        query: {
          room_name: "",
          store_id: null,
          is_validate: null,
          area_id:null,
          page: 1,
          page_size: 10
        },
        form: {
          weekdays: []
        },
        options: [],
        tableData: [],
        pageTotal: 0,
        editVisible: false,
        weekList: [
          {value: 1, label: '周一'},
          {value: 2, label: '周二'},
          {value: 3, label: '周三'},
          {value: 4, label: '周四'},
          {value: 5, label: '周五'},
          {value: 6, label: '周六'},
          {value: 7, label: '周日'},
        ],
        editMealVisible: false, //选择套餐弹出框
        meals: [], //套餐列表
        chooseMeals:[], //已选择套餐
        room_id:0, //房间id 添加套餐时使用
        //压缩
        file :{},
        //裁剪参数
        dialogVisible: false, // 上传图片裁切预览的弹出层是否显示
        previewImage: '', // 预览图片
        cropper: null, // 裁切器实例
        fileName:'', // 文件名称
        updatePhotoLoading: false, // 是否正在更新用户头像 loading显示与否
        rules: {
          room_name: [{required: true, message: '请输入房间名称', trigger: 'blur'}],
          cost: [{required: true, message: '请输入成本', trigger: 'blur'}],
          price: [{required: true, message: '请输入价格', trigger: 'blur'}],
        },
        areaOptions:[],
        area_store:[],
        props: {
          // checkStrictly: true,
          lazy: true,
          lazyLoad:this.lazyLoad
        }
      };
    },
    created() {
      this.init();
    },
  
    computed: {
    },
    methods: {
      init() {
        this.getData();
        this.getMeals()
        this.getStoreOption()
      },
      lazyLoad(node, resolve) {
          const { level } = node;
          if(level === 0){
            this.getAreaOptions()
            let nodes = []
            if(this.areaOptions !== []){
              setTimeout(() => {
                nodes = this.areaOptions.map(item => ({
                  value: item.value,
                  label: item.label,
                  leaf: level >= 1
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }, 500);
            }
          }
          if(level === 1){
            let nodes = []
            this.getStoreOption(node.value)
            if(this.options !== []){
              setTimeout(() => {
                nodes = this.options.map(item => ({
                  value: item.value,
                  label: item.label,
                  leaf: level >= 1
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }, 500);
            }
          }
  
      },
      renderFunc(h, option) {
        return <span title={option.label}>{option.label}</span>;
      },
      handleClose(tag) {
        this.form.weekdays.splice(this.form.weekdays.indexOf(tag), 1)
      },
      handleChange(){},
      dateFormat: function (row, column) {
        const date = row[column.property];
        if (date === undefined) {
          return "";
        }
        return moment(parseInt(date + "000")).format("YYYY-MM-DD")
      },
      // 触发搜索按钮
      handleSearch() {
        this.query.page = 1
        this.getData()
      },
      // 获取地址列表
      getAreaOptions(){
        getAreaOption().then(res=>{
          this.areaOptions = res
        })
      },
      // 搜索
      getData() {
        this.query.area_id = this.area_store!== null ? this.area_store[0] : null
        this.query.store_id = (this.area_store!== null && this.area_store.length>1) ? this.area_store[1] : null
        getRoomList(this.query).then(res => {
          this.tableData = res.data
          if (this.query.page === 1) {
            this.pageTotal = res.count
          }
        })
      },
      save(row) {
        saveRoom(row.id, row).then(res => {
          if (res) {
            this.$message.success('保存成功')
          }
          this.getData()
        })
      },
  
      // 删除操作
      handleDelete(id) {
        // 二次确认删除
        this.$confirm("确定要删除吗？", "删除提示", {
          type: "warning"
        }).then(() => {
          deleteRoom(id).then(res => {
            if (res) {
              this.$message.success('删除成功')
            }
            this.getData()
          })
        }).catch(() => {
        });
      },
  
      //套餐列表
      getMeals() {
        getAllMeal().then(res => {
          let that = this
          res.forEach(function (item) {
            that.meals.push({
              label: item.name + '(' +item.price/100 + '元)',
              key: item.id,
              disable: item.is_validate,
            })
          })
        })
      },
      //套餐
      handleMeal(id) {
        this.getRoomMeals(id)
        this.room_id = id
        this.chooseMeals = []
        this.editMealVisible = true
      },
      getRoomMeals(room_id) {
        getRoomMeal(room_id).then(res => {
          let that = this
          if (res) {
            res.forEach(function (item) {
              that.chooseMeals.push(item.id)
            })
          }
  
        })
      },
      //保存房间套餐
      saveRoomMeal() {
        let param = {
          'room_id' : this.room_id,
          'meal_ids': this.chooseMeals
        }
        // eslint-disable-next-line no-unused-vars
        addRoomMeal(param).then(res => {
          if (res) {
            this.$message.success('保存成功')
            this.editMealVisible = false
          }
          this.room_id = 0
        })
      },
      // 分页导航
      handlePageChange(val) {
        this.query.page = val
        this.getData()
      },
  
      handleEdit(index, row) {
        this.idx = index;
        getRoomDetail(row.id).then(res => {
          this.form = res
          this.form.price = parseFloat(this.form.price / 100).toFixed(2)
          this.form.cost = parseFloat(this.form.cost / 100).toFixed(2)
          // this.form.weekdays = this.form.weekdays || []
          // this.form.weekdays = [1,2,3]
  
        }).then(
            this.editVisible = true
        )
  
  
      },
  
      // 添加操作
      handleAdd() {
        this.form = {}
        this.form.id = 0
        this.form.start_hour = "00:00"
        this.form.end_hour = "00:00"
        this.form.weekdays = [1, 2, 3, 4, 5, 6, 7]
        this.editVisible = true
      },
  
      saveEdit() {
        let data = JSON.parse(JSON.stringify(this.form))
        data.price = parseInt(data.price * 100)
        data.cost = parseInt(data.cost * 100)
        saveRoom(this.form.id, data).then(res => {
          if (res === true) {
            this.$message.success("保存成功")
            this.editVisible = false
            this.getData()
          }
        })
      },
  
      setSort(id, sort) {
        setRoomSort(id, sort).then(res => {
          if (res === true) {
            this.$message.success('保存成功')
          }
        })
      },
  
      getStoreOption(id) {
        this.options = []
        getStoreOption(id).then(res => {
          res.forEach(function (val) {
            this.options.push({label: val.label, value: parseInt(val.value)})
          }, this)
        })
      },
  
      setIsvalidate(index, id, isvalidate) {
        setRoomIsvalidate(id, isvalidate).then(res => {
          if (res === true) {
            this.$message.success('保存成功')
            this.tableData[index].is_validate = isvalidate
          }
        })
      },
  
      // eslint-disable-next-line no-unused-vars
      handleAvatarSuccess(res, file) {
        this.form.cover = res.url
      },
      // eslint-disable-next-line no-unused-vars
      handleListSuccess(res, file) {
        this.form.image_list.push(res.url)
      },
  
      onFileChange () {
        // 处理图片预览
        const file = this.$refs.file
        this.fileName = file.files[0].name
        const blobData = window.URL.createObjectURL(file.files[0])
        this.previewImage = blobData
        // 展示弹出层，预览用户选择的图片
        this.dialogVisible = true
        // 解决选择相同图片不触发change事件的问题
        this.$refs.file.value = ''
      },
  
      // 对话框完全打开后
      onDialogOpened () {
        const image = this.$refs['preview-image']
        const cropper = new Cropper(image, {
          aspectRatio: 10 / 9,
          viewMode: 1,
          dragMode: 'none',
          background: true,
          cropBoxResizable: true,
          // 当你移动裁切器的时候会触发crop方法的调用
        })
        this.cropper = cropper
      },
      onDialogClosed () {
        // this.cropper = null
        this.previewImage = ''
        this.fileName = ''
        this.cropper.destroy()
      },
      async onUpdatePhoto () {
        let img = this.cropper.getCroppedCanvas().toDataURL('image/jpeg')
        let newImg = dataURLtoFile(img, this.fileName)
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
  
        let formData = new FormData();
        formData.append("file", newImg.file);
        upload(formData).then(res => {
          if (res.url === undefined) {
            this.file = {}
          }
          this.form.cover = res.url
          this.file = {}
  
        })
        this.dialogVisible = false
        loading.close();
      },
  
      async beforeAvatarUpload(file) {
        file = await imgCompress(file)
        this.file = file
        file = file.file
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
  
      uploadAvatarFile() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let formData = new FormData();
        formData.append("file", this.file.file);
        upload(formData).then(res => {
          if (res.url === undefined) {
            this.file = {}
          }
          let that = this
          let image_list = that.form.image_list
          if (image_list === undefined) {
            image_list = []
          }
          image_list.push(res.url)
          that.form.image_list = image_list
          this.file = {}
          loading.close();
        })
      },
    }
  };
  </script>
  
  <style scoped>
  .upload{
    float: left;
    margin: 5px;
  }
  .handle-box {
    margin-bottom: 20px;
  }
  
  .handle-select {
    width: 120px;
  }
  
  .handle-input {
    width: 200px;
    display: inline-block;
  }
  
  .table {
    width: 100%;
    font-size: 14px;
  }
  
  .red {
    color: #ff0000;
  }
  
  .mr10 {
    margin-right: 10px;
  }
  
  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }
  
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .el-dialog__body {
    height: 50vh;
    overflow: auto;
  }
  
  /deep/ .el-transfer-panel{
    width: 35%;
  }
  
  .w200{
    width: 200px;
  }
  
  /deep/.el-cascader{
    margin-right: 10px;
  }
  </style>
  